import {
  APP_SET_LOCALE,
  APP_SET_PAGEDATA,
  APP_RESET_PAGEDATA,
  APP_UPDATE_DATA
} from '../actions/app';

export const initialAppState = {
  lang: 'de',
  baseFontSize: 100,
  defaultTheme: false,
  pageData: {}
};

const state = function(state = initialAppState, action) {
  switch (action.type) {
    case APP_SET_LOCALE:
      return {
        ...state,
        lang: action.payload
      };

    case APP_RESET_PAGEDATA:
      return {
        ...state,
        pageData: {}
      };
    case APP_SET_PAGEDATA:
      return {
        ...state,
        pageData: action.payload
      };
    case APP_UPDATE_DATA:
      return {
        ...state,
        pageData: {
          ...state.pageData,
          [action.key]: action.data
        }
      };
    default:
      return state;
  }
};

export default state;
